import { render, staticRenderFns } from "./gdc.html?vue&type=template&id=5bf0a102&scoped=true&"
import script from "./gdc.js?vue&type=script&lang=js&"
export * from "./gdc.js?vue&type=script&lang=js&"
import style0 from "./gdc.scss?vue&type=style&index=0&id=5bf0a102&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0a102",
  null
  
)

export default component.exports